import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/app/(with-header-footer)/trial/[trialId]/trial.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/back/back.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/modal/share-modal/share-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trial/glossary/glossary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trial/trial-detail/trial-detail.tsx");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/trial/trial-detail/trial-tab/tabs/not-yet/not-yet.module.css");
